export function getPageFromString(page: string | undefined): number {
  if (
    typeof page === 'undefined' ||
    page.match(/^[0-9]+$/) === null ||
    isNaN(Number(page))
  ) {
    return 1;
  }
  return Math.round(Number(page));
}
